import React from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import Link from 'gatsby-link';
import _ from 'lodash';
import UserInfo from '../components/Accessories/UserInfo/UserInfo';
import Disqus from '../components/Accessories/Disqus/Disqus';
import SocialLinks from '../components/Accessories/SocialLinks/SocialLinks';
import SEO from '../components/Accessories/SEO/SEO';
import config from '../../data/SiteConfig';

export default class PostTemplate extends React.Component {
  render() {
    console.log(this);
    return null;
    // const slug = this.props.location.pathname;
    // const postNode = this.props.data.wordpressPost;

    // if (!postNode.id) {
    //   postNode.id = slug;
    // }
    // if (!postNode.category_id) {
    //   postNode.category_id = config.postDefaultCategoryID;
    // }

    // return (
    //   <div className="container single-post">
    //     <Helmet>
    //       <title>{`${postNode.title} | ${config.siteTitle}`}</title>
    //     </Helmet>
    //     <SEO postPath={slug} postNode={postNode} postSEO />
    //     <PostContainer>
    //       <h1 className="page-title">{postNode.title} </h1>
    //       <MetaSection>
    //         <div className="info" />
    //       </MetaSection>
    //       <div dangerouslySetInnerHTML={{ __html: postNode.content }} />
    //       <div className="post-meta">
    //         <Divider />
    //         <SocialLinks postPath={slug} postNode={postNode} />
    //         <Divider />
    //         <div className="author">
    //           <h4>By {postNode.author.name}</h4>
    //           <div
    //             className="author-description"
    //             dangerouslySetInnerHTML={{ __html: postNode.author.description }}
    //           />
    //         </div>
    //       </div>
    //       {/* <UserInfo config={config} /> */}
    //       <Disqus postNode={postNode} />
    //     </PostContainer>
    //   </div>
    // );
  }
}

const PostContainer = styled.div`
  .page-title {
    font-size: 5rem;
  }

  .author h4 {
    font-weight: 400;
  }

  .author-description {
    font-size: 2rem;
    margin-bottom: 30px;
  }
`;

const Divider = styled.div`
  border-bottom: 1px solid #ccc;
  margin: 30px 0;
`;

const MetaSection = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 50px;

  img {
    width: 96px;
    height: 96px;
  }
  .cat-link {
    font-size: 2rem;
    margin-left: 2px;
  }
`;

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query PostById($id: String!) {
    wordpressPost(id: { eq: $id }) {
      date
      slug
      title
      modified
      id
      categories {
        name
      }
      author {
        id
        name
        description
      }
      content
    }
    allWordpressPage {
      edges {
        node {
          slug
          title
          id
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/post.jsx